import type { CustomNetworkInformation } from '../types'
import { getNavigatorConnection } from './getNavigatorConnection'

export type NetworkStatus = Pick<
  CustomNetworkInformation,
  'effectiveType' | 'rtt'
> | null

export function getNetworkStatus(): NetworkStatus {
  const connection = getNavigatorConnection()

  if (!connection) {
    return null
  }

  return {
    effectiveType: connection.effectiveType,
    rtt: connection.rtt
  }
}
